import { Box, Tab, Tabs } from "@mui/material"
import BreadCrumbs from "components/Breadcrumbs/Breadcrumbs"
import DrawerHeader from "components/DrawerHeader"
import DisplayEntity from "components/PageBuilder/DisplayEntity"
import { CommonTexts, contentTexts } from "locale/es"
import { useSelector } from "react-redux"
import { Link, Outlet, useLocation } from "react-router-dom"
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import { RolesManager } from "utils/RolesManager"

function Content() {
  const selectedCenterId = useSelector(({ center }) => center)?.data?.id
  const { user } = useSelector(state => state.userAuthentication)

  const location = useLocation()

  const routes = ["/contingut/management", "/contingut/patients"]

  return (
    <Box component="main" sx={{ flex: 1, p: 3, mb: 20 }}>
      <DrawerHeader />
      <BreadCrumbs name={CommonTexts.CONTENT} icon={<CreateNewFolderIcon sx={{ mr: 0.5 }} fontSize="inherit" />} />
      <DisplayEntity entityId={selectedCenterId}>
        <Tabs
          value={
            routes.some(route => route === location.pathname)
              ? location.pathname
              : false
          }
        >
          <Tab
            label={contentTexts.TITLE_CENTRE}
            value={routes[0]}
            component={Link}
            to={routes[0]}
          />
          {RolesManager.userIsProfessional(user.roles) &&
            <Tab
              label={contentTexts.TITLE_PATIENTS}
              value={routes[1]}
              component={Link}
              to={routes[1]}
            />
          }
        </Tabs>
        <Outlet />
      </DisplayEntity>
    </Box>
  )
}

export default Content